/*
**************************************************************************
Title:          Chat component
Created By:     Pankaj Arora
Created on:     05/04/2018
Description:    This component has 3 parts, header, messages & footer.
**************************************************************************
*/
import { Component, ViewChild, ElementRef, OnInit, HostListener, TemplateRef, AfterViewChecked } from '@angular/core';
// import { trigger, state, style, animate, transition } from '@angular/animations';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LiveAnnouncer } from '@angular/cdk/a11y';

import { timer, Observable, Subject, forkJoin, of, concat } from 'rxjs';
import { take, switchMap, catchError } from 'rxjs/operators';
import { delay, tap, mergeMap, repeat } from 'rxjs/operators';

import { User } from '../services/users/user.model';
import { UserService } from '../services/users/user.service';
import { Message } from '../services/messages/message.model';
import { MessageService } from '../services/messages/message.service';
import { ChatAIConnectService } from '../services/api-esme-architecture/chatai-connect.service';
import { LiveChatService } from '../services/live-chat/live-chat.service';
// import { SearchResultComponent } from '../search-result/search-result.component';

import { GetUrlParameters } from '../utils';
import { encode } from 'base64-arraybuffer';
import { webSocket } from 'rxjs/webSocket';
// Enum to identify the context of Search as per action.
// export enum SearchContext {
//   FetchCostCode = 'fetchCostCode',
//   FetchLocation = 'fetchLocation',
//   FetchAuthorisers = 'fetchAuthorisers',
//   FetchAddress = 'fetchAddress',
//   RefNumSearch = 'refNumSearch'
//   // FetchPerson = 'fetchPerson',
//   // FetchCase = 'fetchCase',
//   // CreateCase = 'createCase',
//   // CheckCategorisation = 'checkCategorisation'
// }

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.css'],    
  standalone: false
})
export class ChatComponent implements OnInit, AfterViewChecked {
  @ViewChild('messagesParentDiv') messagesParentDivEl: ElementRef;
  @ViewChild('casePopContent', { static: true }) modalContent: TemplateRef<any>;

  myImgSrc = '/assets/askupload.svg';
  myImgSrcPaperPlane = '/assets/paperplane.png';
  myCloseChat = '/assets/cancelchat.svg';
  messages: Observable<any>;
  draftMessage: Message;
  currentUser: User;
  botUser: User;

  requestInProgress = false;
  showLoading = false;
  waitTime = 2000; // Time to wait for request in ms.
  loadingMessage = 'Processing your request, please wait…';
  // searchContext: SearchContext;
  // closeResult: any;
  // showSearch = false;
  // showSearchResult = false;
  // searchPlaceholder = 'You are now searching...';
  // textToSearch: string; // We can costomize it later for each type of action.
  allMessages: Message[];
  // searchResults: any[] = [];
  // showAuthoritySearchContext = false;
  chatTransactionId: string;
  sessionId: string;

  quickResponseButtonSetInput: {
    btnGroupId: number,
    btnGroup: {
      btnText: string,
      btnResponse: string
    }[],
    width: number
  }[];

  // authorityActionParameters: any;
  showYesNo = false;
  showHeader = true;
  popover: any;
  popoverTitle = 'I am Title';
  popoverContent = 'I have better understanding with shorter sentences, please keep your message brief';
  messagesParentDivHeight: number;
  messagesParentDivOriginalHeight: number;
  firstMessage = new Subject();
  filesToUpload = [];
  showAttachments = false;
  totalImagesUpload = 0;
  attachments = [];

  modalMessage = `Your session will expire at ${(new Date(new Date().getTime() + 5 * 60000)).toTimeString().split(' ')[0].substring(0, 5)} after a further 5 minutes of inactivity`;
  modalTitle = 'User inactivity';
  modalButtons = [];

  userActivity;
  userInactive: Subject<any> = new Subject();
  focusFirstElement = false;
  isFirstTabExit = true;

  formCreateCaseContext: any = {
    name: '',
    email: '',
    phone: '',
    notes: '',
    attachments: [],
    serverAttachments: []
  };
  attachmentError = '';
  disableChatInput = true;
  liveChat: boolean = false;

  wsLiveChatSubject: any;

  @HostListener('window:unload', ['$event'])
  unloadHandler(event) {
    this.reload()
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event) {
    this.reload()
  }

  @HostListener('window:message', ['$event'])
  onMessage(e) {
    if (e?.data?.ariaToken) {
      this.chatAIConnect.setAriaToken(e.data.ariaToken);
      this.sendMessage();
    }
    if (e?.data === 'reset') {

      // end Live chat session
      if (this.liveChat) {
        this.liveChatService.postUserChat('EndChat', this.sessionId).subscribe();
        this.liveChat = false;
        // close websocket connection
        this.wsLiveChatSubject.complete()
        // set Esme as bot user
        this.usersService.setBotUser(new User("Esme"))
      }

      this.messagesService.clearMessages();
      this.chatAIConnect.clearConversationContext();
      this.ngOnInit();
      this.sendMessage();
      this.attachments = [];
      this.totalImagesUpload = 0;
      this.attachmentError = '';
      this.formCreateCaseContext = {
        name: '',
        email: '',
        phone: '',
        notes: '',
        attachments: [],
        serverAttachments: []
      };

    }
  }

  constructor(
    public messagesService: MessageService,
    public usersService: UserService,
    public el: ElementRef,
    public chatAIConnect: ChatAIConnectService,
    public liveChatService: LiveChatService,
    public liveAnnouncer: LiveAnnouncer,
    private modalService: NgbModal
  ) {
    this.setTimeout();
    this.userInactive.subscribe(
      () => this.openLg());
  }

  ngOnInit() {
    this.messages = this.messagesService.messages;

    // todo remove & set current users name
    this.usersService.setCurrentUser(new User('You'));

    // create a draft message for UI binding
    this.draftMessage = new Message();

    // Initialise chat when userId has been passed or running local with hardcoded token in debugging
    if (GetUrlParameters().userId || GetUrlParameters().local) {
      this.sendMessage();
    }

    // subscribe to current user
    this.usersService.currentUser.subscribe(
      (user: User) => this.currentUser = user);

    // subscribe to bot user
    this.usersService.botUser.subscribe(
      (user: User) => this.botUser = user);

    // subscribe to stream of messages
    this.messages.subscribe(
      (messages: Array<Message>) => {
        this.allMessages = messages.filter(m => m.text || m.author.name === 'Esme');
        this.focusFirstElement = true;
      });

    // show hide chat header
    try {
      this.showHeader = GetUrlParameters().locationId || GetUrlParameters().header ? false : true;
    } catch (ex) { }

    // only alert on the first message
    this.firstMessage.pipe(take(1)).subscribe(() => {
      window.parent.postMessage('firstmessage', '*');
    });

  }

  ngAfterViewChecked() {
    if (!this.focusFirstElement) {
      return;
    }
    try {
      const focusable = document.querySelectorAll('button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
      const firstFocusable: HTMLInputElement = focusable[0] as HTMLInputElement;
      if (firstFocusable.id !== 'add-attachments' && firstFocusable.id !== 'restart-chat') {
        firstFocusable.focus();
      } else {
        const messageBox = document.getElementById('message-entry') as HTMLInputElement;
        messageBox.focus();
      }
      this.focusFirstElement = false;
      this.isFirstTabExit = true;
    } catch {
    }
  }

  setTimeout() {
    this.userActivity = setTimeout(() => {
      this.modalTitle = 'User inactivity';
      this.modalMessage = `Your session will expire at ${(new Date(new Date().getTime() + 5 * 60000)).toTimeString().split(' ')[0].substring(0, 5)} after a further 5 minutes of inactivity`;
      this.modalButtons = [];
      this.modalButtons.push({ key: "close", value: "Close" })
      this.userInactive.next(undefined);
    }, 60000 * 25);
  }

  autoShowHidePopover(popover: any) {
    if (this.draftMessage.text.length > 50) {
      popover.open();
      timer(3000).subscribe(() => {
        popover.close();
      });
    }
  }

  // set dynamic height for message container - this is to support multiple option buttons
  // max lines supported are 2.
  setDynamicHeight(totalMessagesWidth: number): any {
    this.messagesParentDivHeight = screen.height - 250;
    return;
    // keep original computed height by the browser
    if (!this.messagesParentDivOriginalHeight) {
      this.messagesParentDivOriginalHeight = this.messagesParentDivEl.nativeElement.offsetHeight;
    }
    // if buttons total width is greater than browser available we need 2 lines for help buttons
    if (totalMessagesWidth > this.messagesParentDivEl.nativeElement.offsetWidth) {
      this.messagesParentDivHeight = Number(this.messagesParentDivOriginalHeight) - 50;
    } else {
      // restore original height
      this.messagesParentDivHeight = this.messagesParentDivOriginalHeight;
    }
  }

  toggleInProgress() {
    this.requestInProgress = !this.requestInProgress;
  }

  toggleLoading() {
    this.showLoading = !this.showLoading;
  }

  toggleChatInput() {
    this.disableChatInput = !this.disableChatInput;
  }

  attachKeyDown(event) {
    if (event.key !== 'Enter') {
      return;
    }
    const attachButton = document.getElementById('file-input') as HTMLInputElement;
    attachButton.click();
  }

  // changedSelectedValue(selectedItem: any): void {
  //   switch (this.searchContext) {
  //     case SearchContext.FetchLocation:
  //       this.draftMessage.text = selectedItem.AreaName || 'Others';
  //       this.sendMessage(selectedItem.LocationId);
  //       // this.sendUIAction();
  //       break;
  //     case SearchContext.FetchCostCode:
  //       // this.draftMessage.text = selectedItem.CostCode;
  //       this.sendMessage(selectedItem.CostCode);
  //       break;
  //     case SearchContext.FetchAuthorisers:
  //       this.draftMessage.text = selectedItem.FirstName + ' ' + selectedItem.LastName;
  //       this.sendMessage(selectedItem.AuthoriserId);
  //       // this.sendMessage(selectedItem.EmailAddress);
  //       // Clean data from authoritySearchContext object for fresh workflow.
  //       this.authoritySearchContext = {
  //         firstName: '',
  //         lastName: '',
  //         email: ''
  //       };
  //       break;
  //     case SearchContext.FetchAddress:
  //       // Need to Address in Message Queue.
  //       this.draftMessage.text = selectedItem.AddressLine2 + ', ' + selectedItem.AddressCity + ', ' + selectedItem.PostCode;
  //       // Need to send Building ID of selected address.
  //       this.sendMessage(`${selectedItem.BuildingId};${selectedItem.SiteID}`);
  //       break;
  //     case SearchContext.RefNumSearch:
  //       this.draftMessage.text = selectedItem.RefNum + ' ' + selectedItem.DefaultLocation;
  //       // // Need to send RefNum of selected record.
  //       this.sendMessage(selectedItem.RefNum);
  //       break;
  //   }

  selectedResponse(clickedButton: any): void {
    // if (this.showAttachments && this.chatAIConnect.getNluAttributes().caseDetails && clickedButton.btnResponse == 'Yes') {
    //   document.getElementById('file-input-img').click();
    //   return;
    // }
    if (clickedButton.btnResponse == 'Connect with Live Agent') {
      let chats = '';
      let chunkChats = []
      let userName = ''
      let nluAttributes = this.chatAIConnect.getNluAttributes();

      this.allMessages.forEach((msg) => {

        if (nluAttributes.userFullName) {
          userName = nluAttributes.userFullName;
        } else {
          // crude but extract user Name from Esme Welcome message
          if (msg.text && msg.text.indexOf('Good') >= 0) {
            let text = msg.text;
            userName = text.split(' ')[2]
          }
        }

        let name = '';
        if (msg.author == this.currentUser) {
          name = "<b>" + userName + "</b>"
        } else {
          name = this.botUser.name
        }

        if (msg.text) {
          // chunk texts
          if ((msg.text + chats).length > 1000) {
            chunkChats.push(chats);
            chats = '';
          }
          chats = chats + ' <p>' + name + ': ' + msg.text + '</p>';
          // replace You with actual username
          chats = chats.replace(`/${this.currentUser.name}/g`, userName);

        }

      });

      // add last chunk to array
      chunkChats.length > 0 ? chunkChats.push(chats) : ''

      if (chunkChats.length > 0) {
        let requests = [];
        // send sequential requests to Mitel
        chunkChats.forEach((chat, index) => {
          // mark the first message to start handoff logging
          requests.push(this.liveChatService.postUserChat(chat.trim(), this.sessionId, index == 0 ? true : undefined));
        });
        concat(...requests).subscribe(result => {
          // success
          console.log(result)
        }, error => {
          this.showLiveAgentError(error)
        }, () => {
          // on complete start live chat
          this.startLiveChat();
        });
      } else {
        // send single request
        // mark the first message to start handoff logging
        this.liveChatService.postUserChat(chats.trim(), this.sessionId, true).subscribe(result => {
          // success
          console.log(result)
          this.startLiveChat();
        }, error => {
          this.showLiveAgentError(error)
        });
      }

    } else {
      this.sendMessage(clickedButton.btnResponse);
    }
    // Fix for the case if user does prefer typing no rather click on Yes/No buttons.
    this.showYesNo = !this.showYesNo;
  }

  selectedOption(option: any) {
    this.sendMessage(option.value || option.label);
  }

  selectedListItem(option: any) {
    this.draftMessage.text = option.label || option.value;
    this.sendMessage(option.value || option.label);
  }

  selectedItem(option: any) {
    this.sendMessage(option);
  }

  // on enter on message input field
  onEnter(event: any): void {

    this.firstMessage.next(event);

    // if there is a request pending, don't let any more messages go.
    this.draftMessage.text = this.draftMessage.text.trim();
    // Breaks AI
    if (this.requestInProgress || this.draftMessage.text === undefined || this.draftMessage.text === '') {
      return;
    }
    if (this.liveChat) {
      this.liveChatService.postUserChat(this.draftMessage.text, this.sessionId).subscribe();
      const msg: Message = new Message();
      msg.author = this.currentUser;
      msg.text = this.draftMessage.text;
      msg.type = 'text';

      this.addMessage(msg)
      this.draftMessage = new Message();
    }
    else {
      this.sendMessage();
    }

    // Fix for the case if user does prefer typing no rather click on Yes/No buttons.
    this.showYesNo = false;
    event.preventDefault();

  }

  // onKeyUp(event: any): void {
  //   switch (this.searchContext) {
  //     // Handle User Inputs for the case of Authority Search
  //     case SearchContext.FetchAuthorisers:
  //       if (this.requestInProgress || this.textToSearch === undefined
  //         || this.authorityActionParameters === undefined || this.authorityActionParameters.length < 1) {
  //         return;
  //       }
  //       // Get input values into a collection.
  //       const userInputs = this.textToSearch.trim().split(' ');

  //       // reset all
  //       this.authoritySearchContext.lastName =
  //         this.authoritySearchContext.firstName =
  //         this.authoritySearchContext.email = '';

  //       userInputs.forEach((text) => {
  //         if (this.regexp.isEmail(text)) {
  //           this.authoritySearchContext.email = text;
  //         } else if (text.startsWith('@')) {
  //           this.authoritySearchContext.lastName = text;
  //         } else if (this.authoritySearchContext.firstName === text || this.authoritySearchContext.lastName === text) {
  //           // do nothing
  //         } else if (!this.authoritySearchContext.firstName) {
  //           this.authoritySearchContext.firstName = text;
  //         } else if (!this.authoritySearchContext.lastName) {
  //           this.authoritySearchContext.lastName = text;
  //         }
  //       });
  //       break;
  //     // Nothing to do for the cases other than Authority Search.
  //     default:
  //       break;
  //   }
  // }


  sendMessage(textToChatAI?: string, hideFromUser?: boolean, ignoreResponse?: boolean): void {
    clearTimeout(this.userActivity);
    this.setTimeout();
    this.messagesParentDivHeight = null;

    this.toggleInProgress();
    if (this.draftMessage.text === '' && textToChatAI === undefined) {
      this.loadingMessage = 'Esme is thinking...';
      // If this is first empty message to wakeup Azure Service. Show Loader immediately.
      timer(0).subscribe(() => {
        this.toggleLoading();
      });
    } else {
      this.loadingMessage = 'Processing your request, please wait…';
      timer(this.waitTime).subscribe(() => {
        this.toggleLoading();
      });
    }

    if (!hideFromUser) {
      this.addMessage(null, this.draftMessage.text || textToChatAI);
    }
    this.chatAIConnect
      .sendToChatAI(textToChatAI || this.draftMessage.text, null, this.attachments)
      .subscribe(
        (response: any) => {
          this.toggleInProgress();
          this.toggleLoading();
          this.disableChatInput = false;

          if (ignoreResponse) {
            return;
          }

          const messageTexts = [];

          let lcLiveChat = false;

          this.chatTransactionId = response.transactionId;
          this.sessionId = response.sessionId;
          // if (this.quickResponseButtonSetInput === undefined) { this.quickResponseButtonSetInput = []; }
          // Intentionally initializing it again without checking for undefined to clear existing content from it.
          this.quickResponseButtonSetInput = [];

          this.showAttachments = response.nluAttributes.showAttachments;
          // if a case is created, reset attachments
          if (this.chatAIConnect.getNluAttributes().caseDetails) {
            this.totalImagesUpload = 0;
            this.attachments = [];
            this.attachmentError = '';
            this.formCreateCaseContext = {
              name: '',
              email: '',
              phone: '',
              notes: '',
              attachments: [],
              serverAttachments: []
            };
            window.parent.postMessage('caseCreated', '*');
          }
          var announcement = '';
          response.message.generic.forEach((genericResponse, index) => {
            const msg: Message = new Message();
            switch (genericResponse.type) {
              case 'text':
                const text = genericResponse.text;
                msg.author = this.botUser;
                msg.text = text.trim();
                msg.type = response.message.type;
                announcement += msg.text + ' ';

                if (genericResponse.display && genericResponse.display.hint && genericResponse.display.hint.type === 'options') {
                  this.showYesNo = true;
                  if (genericResponse.display.hint.values.length > 1) {
                    this.disableChatInput = true;
                  }
                  // Send this collection to quick-response component.
                  const btnGroupCollection = [];
                  let totalWidth = 0;
                  genericResponse.display.hint.values.forEach((value) => {
                    totalWidth = totalWidth + value.length * 10 + 30;
                    btnGroupCollection.push({ btnText: value, btnResponse: value, width: value.length * 10 + 30 });
                  });

                  // option to start Live chat get queue information
                  if (genericResponse.display.hint.values.includes('Connect with Live Agent')) {
                    lcLiveChat = true;
                    msg.showTime = false;
                  }

                  this.quickResponseButtonSetInput.push({ btnGroupId: index, btnGroup: btnGroupCollection, width: 0 });
                  this.setDynamicHeight(totalWidth);
                }
                if (response.message.generic.length !== index + 1) {
                  msg.showTime = false;
                }
                msg.actionParameters = response.actionParameters;
                msg.nluAttributes = response.nluAttributes;
                this.addMessage(msg);
                break;
              case 'tile':
                msg.author = this.botUser;
                msg.tiles.push(genericResponse);
                this.addMessage(msg);
                break;
              case 'list':
                this.disableChatInput = true;
                msg.author = this.botUser;
                msg.list = { ...genericResponse };
                this.addMessage(msg);
                break;
              case 'tree':
                this.disableChatInput = true;
                msg.author = this.botUser;
                msg.list = { ...genericResponse };
                this.addMessage(msg);
                break;
              default:
              // do nothing
            }
          });

          this.liveAnnouncer.announce(announcement);

          if (lcLiveChat) {
            this.showLiveChatQueueInfo()
          }

          messageTexts.forEach((text, index) => {
            const msg: Message = new Message();
            msg.author = this.botUser;
            msg.text = text.text.trim();
            msg.type = response.message.type;

            if (text.display && text.display.hint && text.display.hint.type === 'options') {
              this.showYesNo = true;
              const btnGroupCollection = [];
              let totalWidth = 0;
              text.display.hint.values.forEach((value) => {
                totalWidth = totalWidth + value.length * 10 + 30;
                btnGroupCollection.push({ btnText: value, btnResponse: value, width: value.length * 10 + 30 });
              });

              this.quickResponseButtonSetInput.push({ btnGroupId: index, btnGroup: btnGroupCollection, width: 0 });
              this.setDynamicHeight(totalWidth);
            }

            if (messageTexts.length !== index + 1) {
              msg.showTime = false;
            }
            msg.actionParameters = response.actionParameters;
            msg.nluAttributes = response.nluAttributes;
            if (messageTexts.length === index + 1) {
              msg.tiles = response.message.tiles;
            }

            this.addMessage(msg);
          });
        },
        (error: any) => {
          this.toggleInProgress();
          this.toggleLoading();
          this.disableChatInput = false;

          if (ignoreResponse) {
            return;
          }

          const msg: Message = new Message();
          msg.author = this.botUser;
          try {
            const errorDetails = JSON.parse(error.body || error._body);
            error = errorDetails;
          } catch (ex) {
          }
          msg.text = 'Oops... Something went wrong.';
          // if (this.chatAIConnect.getNluAttributes().liveChatEnabled) {
          //   msg.text += '&nbsp;If you would like further support on this request, you can chat with a live agent.'
          // }
          let msgExplaination = error.errorDetails || error.message;
          if (!msgExplaination) {
            if (typeof error === 'string') {
              msgExplaination = error;
              console.log(JSON.stringify(msgExplaination), msgExplaination);
            }
            else {
              msgExplaination = 'Unexpected technical error';
            }
          }
          if (typeof msgExplaination === 'object') {
            msgExplaination = this.objToString(msgExplaination);
          }
          if (msgExplaination) {
            // Need to make sure the case of session expired.
            if (msgExplaination.includes('Session is expired')) {
              // Need to show a informative message to user.
              msg.text = 'Your session has Expired, we are reconnecting you.';
              // Need to reconnect in backgroud by sending a blank message.
              // this.sendMessage();
              this.chatAIConnect.clearConversationContext();
              this.ngOnInit();

              if (this.chatAIConnect.getAriaToken()) {
                this.sendMessage();
              }
            }
            msg.text = `<span class="">${msg.text}</span> <br /> <small class="text-danger">${msgExplaination}</small>`;
          }
          msg.isError = true;
          if (this.chatAIConnect.getNluAttributes().liveChatEnabled) {
            this.showYesNo = true;

            // Send this collection to quick-response component.
            const btnGroupCollection = [];
            let totalWidth = 0;

            if (this.sessionId) {
              this.showLiveChatQueueInfo();
              totalWidth = totalWidth + 'Connect with Live Agent'.length * 10 + 30;
              btnGroupCollection.push({ btnText: 'Connect with Live Agent', btnResponse: 'Connect with Live Agent', width: 'Connect with Live Agent'.length * 10 + 30 });
            }

            this.quickResponseButtonSetInput = [];
            this.quickResponseButtonSetInput.push({ btnGroupId: 0, btnGroup: btnGroupCollection, width: 0 });
            this.setDynamicHeight(totalWidth);

          }
          this.addMessage(msg);
        }
      );
    this.draftMessage = new Message();
  }

  private addMessage(msg?: Message, text?: string, user?: User): void {
    if (msg) {
      this.messagesService.addMessage(msg);
    }
    const message: Message = new Message();
    message.text = text;
    message.author = user || this.currentUser;
    this.messagesService.addMessage(message);
  }

  private objToString(obj: any): string {
    let result = '';
    if (typeof obj === 'string') {
      return obj;
    }
    for (const param in obj) {
      if (obj.hasOwnProperty(param)) {
        result += param + ': ' + this.objToString(obj[param]) + '<br />';
      }
    }
    return result;
  }

  // async takePhoto() {
  //   const image = await Camera.getPhoto({
  //     quality: 90,
  //     allowEditing: false,
  //     resultType: CameraResultType.DataUrl,
  //     source: CameraSource.Camera
  //   });}

  //   // Process the captured image
  //   // ...

  // // Function to select a photo from the device's gallery
  // async selectFromGallery() {
  //   const image = await Camera.getPhoto({
  //     quality: 90,
  //     allowEditing: false,
  //     resultType: CameraResultType.DataUrl,
  //     source: CameraSource.Photos
  //   });
  // }

  handleFileInput = (files: FileList) => {
    this.attachmentError = '';
    if (files.length < 1) {
      return false;
    }
    // number of files
    if (files.length > 5 || this.totalImagesUpload + files.length > 5) {
      const msg: Message = new Message();
      msg.author = this.botUser;
      if (this.totalImagesUpload) {
        msg.text = `<span class="">Attached photos limit reached</span> <br /> <small class="text-danger">Total number of files ${files.length + this.totalImagesUpload} exceeds limit of 5</small>`;
      } else {
        msg.text = `<span class="">Attached photos limit reached</span> <br /> <small class="text-danger">Total number of files selected is ${files.length} exceeds limit of 5</small>`;
      }
      msg.isError = true;
      this.addMessage(msg);
      this.attachmentError = msg.text;
      return;
    }
    const observables = [];
    for (let i = 0; i < files.length; i++) {
      const fileToUpload = files.item(i);

      if (fileToUpload.size > 10200000) {
        const msg: Message = new Message();
        msg.author = this.botUser;
        msg.text = `<span class="">Photo too large</span> <br /> <small class="text-danger">File ${fileToUpload.name} size exceeds limit of 10mb</small>`;
        msg.isError = true;
        this.addMessage(msg);
        this.attachmentError = msg.text;
        return;
      }

      if (files.item(i).type.indexOf('image') < 0) {
        const msg: Message = new Message();
        msg.author = this.botUser;
        msg.text = `<span class="">Incorrect file type, only upload images</span> <br /> <small class="text-danger">File type ${files.item(i).type} is not valid</small>`;
        msg.isError = true;
        this.addMessage(msg);
        this.attachmentError = msg.text;
        return;
      }
    }
    // all good upload files
    for (let i = 0; i < files.length; i++) {
      const fileToUpload = files.item(i);
      observables.push(this.getBase64EncodedFileData(fileToUpload).pipe(
        switchMap((stringData) => this.chatAIConnect
          .sendToChatAI('', { name: fileToUpload.name, filedata: stringData })
          .pipe(catchError((err) => of(err)))
        )));
    }

    this.toggleInProgress();
    this.toggleLoading();
    let uploadsSuccesfull = true;

    concat(...observables)
      .subscribe((response: any) => {
        // backend error occurred
        if (response.errorDetails) {
          const msg: Message = new Message();
          msg.author = this.botUser;
          msg.text = `<span class="">File upload error</span> <br /> <small class="text-danger">${response.errorDetails}</small>`;
          msg.isError = true;
          this.addMessage(msg);
          this.attachmentError = msg.text;
          uploadsSuccesfull = false;
          return;
        }

        let localTotalImagesUpload = 0;

        if (response.message && response.message.generic.length > 0) {
          const msg: Message = new Message();
          msg.author = this.botUser;
          msg.text = response.message.generic[0].text;
          if (msg.text) {
            msg.isError = true;
            this.addMessage(msg);
          }
          document.getElementById('file-input-img').click();
        }
        // fdis change, backend sends back all attachments
        this.totalImagesUpload = response.attachments.length;
        localTotalImagesUpload = response.attachments.length;
        this.attachments = response.attachments;
        // remove any potential duplicates from parallel processing
        // this.attachments = this.attachments.filter((value, index, self) => 
        //   index === self.findIndex((obj) => obj.name === value.name)
        // );

      }, error => {
        if (error.errorDetails) {
          const msg: Message = new Message();
          msg.author = this.botUser;
          msg.text = `<span class="">File upload error</span> <br /> <small class="text-danger">${error.errorDetails}</small>`;
          msg.isError = true;
          this.addMessage(msg);
          this.attachmentError = msg.text;
          uploadsSuccesfull = false;
        }
      }, () => {
        // on complete
        this.toggleInProgress();
        this.toggleLoading();
        if (uploadsSuccesfull) {
          for (let i = 0; i < files.length; i++) {
            const fileToUpload = files.item(i);
            const fileObservables = [];
            fileObservables.push(this.getFileUrl(fileToUpload));

            forkJoin(fileObservables)
              .subscribe((fileResponses: any) => {
                fileResponses.forEach((response) => {
                  this.formCreateCaseContext.attachments.push(response);
                });
              });
          }
        }
      });
  }

  getFileUrl(file: File): Observable<any> {
    return new Observable(observer => {
      const reader = new FileReader();
      reader.onload = () => {
        const { result } = reader;
        const url = result as string; // <--- FileReader gives us the ArrayBuffer
        observer.next({ url, name: file.name });
        observer.complete();
      };
      reader.onerror = () => {
        observer.error(reader.error);
      };
      reader.readAsDataURL(file);
    });
  }

  getBase64EncodedFileData(file: File): Observable<string> {
    return new Observable(observer => {
      const reader = new FileReader();
      reader.onload = () => {
        const { result } = reader;
        const data = result as ArrayBuffer; // <--- FileReader gives us the ArrayBuffer
        const base64Encoded = encode(data); // <--- convert ArrayBuffer to base64 string

        observer.next(base64Encoded);
        observer.complete();
      };
      reader.onerror = () => {
        observer.error(reader.error);
      };
      reader.readAsArrayBuffer(file);
    });
  }

  openLg(resetForm?: boolean) {
    const modalRef = this.modalService.open(this.modalContent, { size: 'lg' });
    modalRef.result.then((result) => {
      if (resetForm) {
        // this.reset();
      } else {
        this.setTimeout()
      }
    });
  }

  restartChat() {

    let nluAttributes = this.chatAIConnect.getNluAttributes();

    if (nluAttributes.liveChatEnabled && nluAttributes.pointer != 'master') {

      this.liveChatService.getUserChatInfo(this.sessionId).subscribe((response: any) => {

        if (response.isInDoNotDisturb || response.agentsAvailable == 0) {
          // just restart chat, no agent available
          this.reload()
        } else {

          let waitTime = response.longestWaitingConversationDuration.split(":")
          let waitTimeText = []
          if (Number(waitTime[0] > 0)) {
            waitTimeText.push(waitTime[0] + ' hour(s)')
          }
          if (Number(waitTime[1] > 0)) {
            waitTimeText.push(Number(waitTime[1]).toString() + ' minute(s)')
          }
          if (Number(waitTime[2] > 0)) {
            waitTimeText.push(Number(waitTime[2]).toString() + ' second(s)')
          }
          if (waitTimeText.length == 0) {
            // if there's a zero wait time, show some random seconds between 10 & 40 for aync process to establish connection
            waitTimeText.push((Math.floor(Math.random() * 30) + 10).toString() + ' second(s)')
          }

          let title = `${response.agentsAvailable} customer service operative(s) are online, your estimated position in the queue will be ${response.waitingConversations + 1}.`;
          let subtitle = `Current wait time is approximately ${waitTimeText.join(' ')}.`;

          this.modalTitle = 'Restart chat';
          this.modalMessage = `Are you sure you want to restart the chat? If you need further assistance, you can also connect to a live agent.
                          <div class="card bg-light">
                            <div class="card-header brand-color">
                              ${title}
                            </div>
                            <div class="card-body"><h5 class="card-title">${subtitle}</h5></div></div>`;

          this.modalButtons = [];
          this.modalButtons.push({ key: "liveAgent", value: "Connect with Live Agent", primary: true });
          this.modalButtons.push({ key: "restart", value: "Restart chat", primary: true });
          this.modalButtons.push({ key: "close", value: "Close" });

          const modalRef = this.modalService.open(this.modalContent, { size: 'lg' });
          modalRef.result.then((result) => {

            switch (result) {
              case 'restart':
                this.reload()
                break;
              case 'liveAgent':
                let button = { btnResponse: 'Connect with Live Agent' };
                this.selectedResponse(button);
                break;
              default:
                // do nothing - close the popup
                break;
            }
          });
        }
      },
        (error: any) => {
          // just restart chat
          this.reload()
        });
    } else {
      // just restart chat
      this.reload()
    }

  }
  playSound(){
    let audio = new Audio();
    audio.src = "/assets/rtone.wav";
    audio.load();
    audio.play();
  }
  reload() {
    this.showYesNo = false;
    // end Live chat session
    if (this.liveChat) {
      this.liveChatService.postUserChat('EndChat', this.sessionId).subscribe();
      this.liveChat = false;
      // restarts Esme session & resets Watson context
      this.chatAIConnect.clearConversationContext();
      this.sendMessage();
      // close websocket connection
      this.wsLiveChatSubject.complete()
      // set Esme as bot user
      this.usersService.setBotUser(new User("Esme"))
    } else {
      // inform current session of Esme that user restarted chat
      this.sendMessage('Restart chat', true, true);

      this.allMessages = [];
      this.messagesService.clearMessages();
      this.chatAIConnect.clearConversationContext();
      this.formCreateCaseContext.attachments = [];
      this.attachments = [];
      this.totalImagesUpload = 0;
      this.sendMessage();
    }
  }

  display(response) {
    console.log(response)
  };

  async startWebSocket() {

    this.liveChatService.negotiate(this.sessionId).subscribe(
      (response: any) => {
        this.wsLiveChatSubject = webSocket(response);

        this.wsLiveChatSubject.subscribe({
          next: sockMessage => {
            this.showLoading = false;
            if (sockMessage['message']) {
              // hide spinner
              this.disableChatInput = false;
              this.requestInProgress = false;

              const msg: Message = new Message();
              msg.type = sockMessage['eventType'];
              msg.author = this.botUser;
              msg.text = sockMessage['message'];

              if (msg.type == 'system-message') {
                msg.showTime = false;
              }

              if (sockMessage['eventMessage'] == "micc-participant-added") {
                let agentName = msg.text.split(" ")[0];
                this.usersService.setBotUser(new User(agentName || "Mitie Agent"))
              }
              this.playSound();
              this.addMessage(msg);

              if (sockMessage['eventMessage'] == "micc-session-complete") {
                this.liveChat = false;
                this.usersService.setBotUser(new User("Esme"))
                msg.text = msg.text + 'd by Agent.'
                // reset Esme backend nluContext
                this.chatAIConnect.clearConversationContext();
                this.sendMessage();

              } else if (sockMessage['eventMessage'] == "micc-session-timeout") {
                this.liveChat = false;
                this.usersService.setBotUser(new User("Esme"))
                // reset Esme backend nluContext
                this.chatAIConnect.clearConversationContext();
                this.sendMessage();
              } else if (msg.type == 'system-message' && msg.text.indexOf('just joined') < 0) {
                // unhandled/unknown micc events
                msg.text = `Your chat session encountered an unexpected event, ${msg.text}, please check if Agent is connected by sending a message.`

              }
            }
            console.log('message received: ' + JSON.stringify(sockMessage))
          }, // Called whenever there is a message from the server.
          error: err => {
            console.log(err)
            this.wsLiveChatSubject.complete()
          }, // Called if at any point WebSocket API signals some kind of error.
          complete: () => console.log('complete') // Called when connection is closed (for whatever reason).
        });
      })
  }

  startLiveChat() {

    this.showAttachments = false;
    this.loadingMessage = 'We are connecting you with an agent, please wait...';
    this.toggleInProgress();
    this.toggleLoading();

    this.startWebSocket();
    this.liveChat = true;
    this.disableChatInput = true;

  }

  showLiveChatQueueInfo() {
    this.liveChatService.getUserChatInfo(this.sessionId).subscribe((response: any) => {

      let helpdeskNumber = this.chatAIConnect.getNluAttributes().helpdeskNumber;

      // if (response.isInDoNotDisturb) {
      //   this.showYesNo = false;
      //   this.disableChatInput = false;

      //   const msg: Message = new Message();
      //   msg.type = 'text';
      //   helpdeskNumber ?
      //     msg.text = 'Sorry, live agent support is unavailable at this time. You can contact the customer service desk on ' + helpdeskNumber :
      //     msg.text = 'Sorry, live agent support is unavailable at this time.';
      //   msg.author = this.botUser;
      //   this.addMessage(msg);

      // } else if (response.agentsAvailable == 0) {
      //   this.showYesNo = false;
      //   this.disableChatInput = false;

      //   const msg: Message = new Message();
      //   msg.type = 'text';
      //   helpdeskNumber ?
      //     msg.text = 'Sorry, none of our agents are online at this time. You can contact the customer service desk on ' + helpdeskNumber :
      //     msg.text = 'Sorry, none of our agents are online at this time.';

      //   msg.author = this.botUser;
      //   this.addMessage(msg);
      // }
      if (response.isInDoNotDisturb || response.agentsAvailable == 0) {
        this.showYesNo = false;
        this.disableChatInput = false;

        const msg: Message = new Message();
        msg.type = 'text';
        helpdeskNumber ?
          msg.text = 'or alternatively, you can contact the customer service desk on ' + helpdeskNumber : 'or alternatively, you can contact the customer service desk.'

        msg.author = this.botUser;
        this.addMessage(msg);
      }
      else {

        const msgL: Message = new Message();
        msgL.type = 'text';
        msgL.text = 'or alternatively, if you would like further support on this request, you can chat with a live agent.'

        msgL.author = this.botUser;
        this.addMessage(msgL);

        let waitTime = response.longestWaitingConversationDuration.split(":")
        let waitTimeText = []
        if (Number(waitTime[0] > 0)) {
          waitTimeText.push(waitTime[0] + ' hour(s)')
        }
        if (Number(waitTime[1] > 0)) {
          waitTimeText.push(Number(waitTime[1]).toString() + ' minute(s)')
        }
        if (Number(waitTime[2] > 0)) {
          waitTimeText.push(Number(waitTime[2]).toString() + ' second(s)')
        }
        if (waitTimeText.length == 0) {
          // if there's a zero wait time, show some random seconds between 10 & 40 for aync process to establish connection
          waitTimeText.push((Math.floor(Math.random() * 30) + 10).toString() + ' second(s)')
        }
        // rShow Mitel queue information
        const msg: Message = new Message();
        msg.type = 'tile';
        msg.author = this.botUser;
        let tile = {
          title: `${response.agentsAvailable} customer service operative(s) are online, your estimated position in the queue will be ${response.waitingConversations + 1}.`,
          subtitle: `Current wait time is approximately ${waitTimeText.join(' ')}.`,
          quoteValue: null,
          list: []
        };
        msg.tiles.push(tile);
        this.playSound();
        this.addMessage(msg);
      }
    },
      (error: any) => {
        this.showLiveAgentError(error)
      });
  }

  // error handler for live agent
  showLiveAgentError(error: any) {
    let msgExplaination = error.errorDetails || error.message;
    if (!msgExplaination) {
      if (typeof error === 'string') {
        msgExplaination = error;
        console.log(JSON.stringify(msgExplaination), msgExplaination);
      }
      else {
        msgExplaination = 'Unexpected technical error';
      }
    }
    if (typeof msgExplaination === 'object') {
      msgExplaination = this.objToString(msgExplaination);
    }

    this.showYesNo = false;
    this.disableChatInput = false;
    let helpdeskNumber = this.chatAIConnect.getNluAttributes().helpdeskNumber;
    const msg: Message = new Message();
    msg.type = 'text';

    // helpdeskNumber ?
    //   msg.text = 'Sorry, live agent support is unavailable at this time. You can contact the customer service desk on ' + helpdeskNumber :
    //   msg.text = 'Sorry, live agent support is unavailable at this time.';

    helpdeskNumber ?
      msg.text = 'Sorry, something went wrong. You can contact the customer service desk on ' + helpdeskNumber :
      msg.text = 'Sorry, something went wrong. You can contact the customer service desk';

    msg.text = `<span class="">${msg.text}</span> <br /> <small class="text-danger">${msgExplaination}</small>`;
    msg.author = this.botUser;
    this.addMessage(msg);
  }

}
